import React from "react";

function Title(props) {
    return(
        <p className='label-large white' style={{maxWidth: "70vw", marginTop: "1.2rem"}}>
            {props.content}
        </p>
    );
}

function Desc(props) {
    return(
        <p className='headline-large neutrals' style={{marginTop: "0.8rem", maxWidth: "70vw", marginBottom: "2.4rem"}}>
            {props.content}
        </p>
    );
}

function RoleIntro() {
    return(
        <div style={{
            display: "flex",
            flexDirection: "row",
            width: "70vw",
            gap: "4vw" ,
            marginLeft: "auto",
            marginRight: "auto",
            justifyContent: "center",
            marginTop: "20vh",
            marginBottom: "20vh"
        }}>
            <div style={{
                width: "33vw"}}>
                <Title content="MY ROLE"/>
                <Desc content="Product Designer"/>
                <Title content="TIMELINE"/>
                <Desc content="Feb 2024 - Present"/>
            </div>
            
            <div style={{
                width: "33vw"}}>
                <Title content="MY TEAMS"/>
                <Desc content="At TikTok, I had the opportunity to work across two impactful teams - Creation Team & Responsibility Team, each shaping the platform in unique and meaningful ways. "/>
            </div>
        </div>
        
    )
}

export default RoleIntro;
